import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["inputRef", "onChange", "property", "inputSize"];
import PropTypes from 'prop-types';
import CRMPropertyDateInput from 'customer-data-properties/date/CRMPropertyDateInput';
import { MomentTypes } from 'customer-data-properties/date/MomentTypes';
import SyntheticEvent from 'UIComponents/core/SyntheticEvent';
import PropertyPropType from '../utils/propTypes/PropertyPropType';
import { getTransferrableProps } from '../utils/getTransferrableProps';
import { memo, useCallback } from 'react';
import refObject from 'UIComponents/utils/propTypes/refObject';
import { DATE } from 'customer-data-objects/property/PropertyTypes';
import { useShowRelativeDateValue } from '../date/useShowRelativeDateValue';
import { jsx as _jsx } from "react/jsx-runtime";
const propTypes = {
  inputRef: refObject.isRequired,
  onChange: PropTypes.func,
  property: PropertyPropType.isRequired,
  value: PropTypes.string
};
const PropertyInputDate = _ref => {
  let {
      inputRef,
      onChange,
      property,
      inputSize
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const showRelativeDateValue = useShowRelativeDateValue();
  const handleChange = useCallback(evt => {
    const {
      target: {
        value
      }
    } = evt;
    if (typeof onChange === 'function') {
      // CRMPropertyDateInput (UIDateInput)'s onChange sends `number | null`; convert to `string | null`
      onChange(value == null ? SyntheticEvent(null) : SyntheticEvent(String(value)));
    }
  }, [onChange]);
  return /*#__PURE__*/_jsx(CRMPropertyDateInput, Object.assign({}, getTransferrableProps(rest), {
    momentType: MomentTypes.USER,
    onChange: handleChange,
    inputRef: inputRef,
    inputSize: inputSize,
    type: property.type === DATE ? 'date' : undefined,
    showRelativeDateValue: showRelativeDateValue
  }));
};
PropertyInputDate.propTypes = propTypes;
export default /*#__PURE__*/memo(PropertyInputDate);